"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require("redbox-react");

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require("react");

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require("react-transform-catch-errors");

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require("react-redux");

var _helpers = require("helpers");

var _constants = require("redux/constants");

var _reactRouter = require("react-router");

var _catalog = require("redux/actions/catalog");

var _utils = require("redux/modules/catalog/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Menu: {
        displayName: "Menu"
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: "/usr/local/ibonus/src/components/Menu/Menu.jsx",
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Menu = _wrapComponent("Menu")((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        location: state.routing.locationBeforeTransitions.pathname,
        categories: state.catalog.categories,
        categoriesLoading: state.catalog.categoriesLoading,
        lang: state.lang,
        setting: state.setting
    };
}, {
    refreshCatalog: _catalog.refreshCatalog,
    getCatalog: _catalog.getCatalog,
    getByCategory: _catalog.getByCategory,
    hasOffersInRootCategory: _catalog.hasOffersInRootCategory
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Menu, _Component);

    function Menu(props) {
        (0, _classCallCheck3.default)(this, Menu);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props));

        _this.state = {
            showMenu: false // скрывать по умолчанию на главной в мобильной!
        };
        return _this;
    }

    (0, _createClass3.default)(Menu, [{
        key: "componentWillReceiveProps",


        // Сброс состояния при обновлении компонента
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.categoriesLoading !== nextProps.categoriesLoading) {
                this.props.categoriesLoading ? this.closeMenu() : this.openMenu();
            }

            if (this.props.drop !== nextProps.drop) {
                nextProps.drop && this.closeMenu();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var View = _helpers.ThemeHelper.getViewForComponent("Menu");

            return _react3.default.createElement(View, (0, _extends3.default)({}, this.props, {
                onClick_Category: function onClick_Category(data) {
                    return _this2.onClick_Category(data);
                },
                openMenu: function openMenu() {
                    return _this2.openMenu();
                },
                closeMenu: function closeMenu() {
                    return _this2.closeMenu();
                },
                toggleMenu: function toggleMenu() {
                    return _this2.toggleMenu();
                },
                showMenu: this.state.showMenu,
                buyInCreditActive: this.props.setting.buyInCreditActive,
                buyInCredit: this.props.setting.buyInCredit
            }));
        }
    }, {
        key: "onClick_Category",
        value: function onClick_Category(_ref) {
            var _this3 = this;

            var id = _ref.id,
                children = _ref.children;

            if (id === null) {
                return;
            }
            this.props.refreshCatalog().then(function () {
                var found = (0, _utils.findCategoryDeep)(_this3.props.categories, id);
                if (found !== null) {
                    _reactRouter.browserHistory.push("/category/" + id + "?limit=" + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + "&page=1");
                } else {
                    _reactRouter.browserHistory.push("/");
                }
            });

            this.closeMenu();
        }
    }, {
        key: "openMenu",
        value: function openMenu() {
            this.setState({ showMenu: true });
        }
    }, {
        key: "closeMenu",
        value: function closeMenu() {
            this.setState({ showMenu: false });
        }
    }, {
        key: "toggleMenu",
        value: function toggleMenu() {
            this.setState(function (prevState) {
                return { showMenu: !prevState.showMenu };
            });
        }
    }]);
    return Menu;
}(_react2.Component), _class2.propTypes = {
    categories: _react2.PropTypes.array.isRequired,
    lang: _react2.PropTypes.object
}, _class2.defaultProps = {
    categories: []
}, _temp)) || _class));

exports.default = Menu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/Menu.jsx
// module id = 1681
// module chunks = 0